'use strict';
/**
 * Helper class
 *
 * @type class
 */
export default class Helpers {
    /**
     * Process dataLayer dot notation string into object reference
     *
     * @param  object   dataLayer
     * @param  object?  custom_model       custom model to reference. if none provided, will check against window.rddl
     * @param  object?  dataLayer_final    clone of dataLayer, parameter used for recursion
     * @return object
     */
    process_datalayer(dataLayer, custom_model, dataLayer_final) {
        // Clone the dataLayer so it's unique to the event
        if (!dataLayer_final)
            dataLayer_final = structuredClone(dataLayer);
        // Loop through dataLayer
        for (var key in dataLayer_final) {
            let ref = null;
            // Parse dataLayer dot notation references
            if (typeof dataLayer_final[key] === 'string') {
                // If provided, check against custom model first
                if (custom_model) {
                    ref = dataLayer_final[key].split('.').reduce((o, x) => {
                        return (o && o[x] !== null && o[x] !== undefined) ? o[x] : null;
                    }, custom_model);
                }
                // Push to final dataLayer
                if (ref !== null) {
                    dataLayer_final[key] = ref;
                }
                // Check against window.rddl
                else {
                    ref = dataLayer_final[key].split('.').reduce((o, x) => {
                        return (o && o[x] !== null && o[x] !== undefined) ? o[x] : null;
                    }, window.rddl);
                    if (ref !== null) {
                        dataLayer_final[key] = ref;
                    }
                }
            }
            // Recursively process nested objects
            else if (typeof dataLayer_final[key] === 'object') {
                this.process_datalayer(dataLayer_final[key], custom_model, dataLayer);
            }
        }
        return dataLayer_final;
    }
}
